/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Education_High_SchoolInputs */

const en_onboarding_education_high_school = /** @type {(inputs: Onboarding_Education_High_SchoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High school`)
};

const es_onboarding_education_high_school = /** @type {(inputs: Onboarding_Education_High_SchoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparatoria`)
};

/**
* | output |
* | --- |
* | "High school" |
*
* @param {Onboarding_Education_High_SchoolInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_education_high_school = /** @type {((inputs?: Onboarding_Education_High_SchoolInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Education_High_SchoolInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_education_high_school(inputs)
	return en_onboarding_education_high_school(inputs)
});